/**
 * Debounce delay before a HITL draft autosave fires.
 */
export const DraftAutosave = {
	delayMs: 1000,
	retryDelaysMs: [1000, 2000, 4000],
} as const;
